import dayjs from "dayjs";
import { useCallback } from "react";
import { displayDateFormat } from "tm-shared/constants";

import { useAppSelector } from "@/hooks/redux";

import { TIME_INTERVALS } from "../constants";

export const useScheduleStatus = (userId: string, isActive: boolean) => {
    const lastUpdated = useAppSelector(
        (state) => state.manager.lastUpdated.activeSchedule,
    );
    const activeSchedule = useAppSelector(
        (state) => state.manager.activeSchedule,
    );

    const hasSchedule = useCallback(() => {
        if (
            !activeSchedule ||
            !lastUpdated ||
            dayjs(lastUpdated, displayDateFormat.dateTimeSeconds).isBefore(
                dayjs().subtract(TIME_INTERVALS.SCHEDULE_EXPIRY_DAYS, "day"),
            )
        ) {
            return false;
        }

        return activeSchedule.userId === userId;
    }, [activeSchedule, lastUpdated, userId]);

    const canAccess = isActive;

    return {
        hasSchedule: hasSchedule(),
        canAccess,
    };
};
